import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../services/auth.service';
import { GlobalConstants } from '../global-constants';
import { CustomerLoginDialogComponent } from './customer-login.component';
import { DriverLoginDialogComponent } from './driver-login.component';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
  logedin = false;
  cuname = '';

  constructor(public dialog: MatDialog, private authService: AuthService) {}

  ngOnInit(): void {
    $(document).ready(() => {
      if ($(window).width() < 767) {
        $('.start-header .navurl').click((e: any) => {
          e.preventDefault();
          $('.navbar-toggler').trigger('click');
        });
      }
    });
    this.checkLoggedin();
  }

  logout(): void {
    this.authService.clearSession();
    window.location.replace(GlobalConstants.websiteURL);
  }

  checkLoggedin(): void {
    this.logedin = this.authService.isLoggedIn();
    if (this.logedin) {
      this.cuname = this.authService.getCustomerName();
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(CustomerLoginDialogComponent);
    dialogRef.afterClosed().subscribe(result => console.log(`Dialog result: ${result}`));
  }

  openDialog2(): void {
    const dialogRef = this.dialog.open(DriverLoginDialogComponent);
    dialogRef.afterClosed().subscribe(result => console.log(`Dialog result: ${result}`));
  }
}
